import { Button, Modal } from "@xola/ui-kit";
import React from "react";
import { SecondaryButton } from "@/components/Common/SecondaryButton";
import { ConfirmationModalProps } from "@/hooks/useConfirmationModal";

type Props = ConfirmationModalProps;

export const ConfirmDataRetentionPolicyModal = ({ isOpen, onClose, onContinue }: Props) => {
    return (
        <Modal isOpen={isOpen} size="medium" onClose={onClose}>
            <Modal.Header onClose={onClose}>Confirm Data Retention Policy</Modal.Header>
            <Modal.Body>
                <div className="space-y-4 text-gray-darker">
                    <p>
                        Are you sure you want to apply these changes? This will immediately begin masking PII data for
                        all records that exceed the selected timeframe.
                    </p>
                    <p>Records from reservations with an open dispute will not be masked.</p>
                    <p>
                        While you can modify the retention period again in the future, data that has been masked cannot
                        be restored.
                    </p>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <SecondaryButton onClick={onClose}>Cancel</SecondaryButton>
                <Button color="danger" onClick={onContinue}>
                    Confirm and Mask Data
                </Button>
            </Modal.Footer>
        </Modal>
    );
};
